import React from "react";
import { Box, Pagination, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const OutlinedPagination = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Outlined Pagination
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"Outlined pagination in circular and rounded shape"}
          value={
            '      <Pagination count={10} variant={"outlined"} />\n' +
            '          <Pagination count={10} variant={"outlined"} color={"primary"} />\n' +
            '          <Pagination count={10} variant={"outlined"} shape={"rounded"} color={"secondary"}/>\n' +
            '          <Pagination count={10} variant={"outlined"} shape={"rounded"} />'
          }
        >
          <Stack spacing={2}>
            <Pagination count={10} variant={"outlined"} />
            <Pagination count={10} variant={"outlined"} color={"primary"} />
            <Pagination
              count={10}
              variant={"outlined"}
              shape={"rounded"}
              color={"secondary"}
            />
            <Pagination count={10} variant={"outlined"} shape={"rounded"} />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default OutlinedPagination;
